<template>
  <div>
    <!--  -->
    <v-btn color="info" @click="showInterest" large
      ><v-icon left>mdi-plus-box</v-icon>{{ $t('project.add_interested_person') }}</v-btn
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      isInterest: false,
    };
  },
  methods: {
    showInterest() {
      this.$emit("onClickCreate");
    },
    emitToMainComponent() {
      this.$emit("onFormCreate");
    },
  },
};
</script>

<style>
</style>